import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/small_icon_MM_fuction_subscription.png")